module.exports = __webpack_public_path__ + "static/media/email.a4dd7f69.svg";